import { toCamelCase } from 'src/utils/caseMappers';

import apiRequest from './apiRequest';
import EP from './endpoints';

export const getData = () => apiRequest(EP.dashboard).then(({ meta }) => toCamelCase(meta));
